/**
 * True when the user can run OpenAI-backed features (BYOK and/or allowed app default key).
 */
export function isLlmInferenceAvailable(user) {
  if (!user) return false;
  if (typeof user.llm_inference_available === 'boolean') {
    return user.llm_inference_available;
  }
  return !!user.has_api_key;
}
